<template>
    <div class="container-fluid mt--6 tbl-flt-sch">
      <div class="row xsOnly">
        <div class="col-xl-12">
            <div class="card scrollbar vh-75" id="scroll">
                <div class="table-responsive">
                    <h4 class="d-inline-block py-4">
                  <div class="">
                    Total Quantity  : <span class="badge">{{totalCount ? totalCount : 0}}</span> 
                    Total Price : <span class="badge">{{totalPrice | currency}}</span>
                  </div>
                </h4>
                    <div class="input-group col-md-2 tab-sch tbl-sch rounded">
                        <input v-on:keyup.enter="searchInventory" type="text" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control rounded" placeholder="Search" />
                        <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
                        <span @click="searchInventory()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
                    </div>
                    <div class="col-md-3 tbl-filter mt-2">
                    <multiselect 
                                v-model="filterUser" 
                                placeholder="Filter By User" 
                                label="firstName" 
                                track-by="id"
                                :options="userList" 
                                :limit="3"  ></multiselect>
                    <button @click="searchInventory()" type="button" class="flt-btn btn btn-success"><i class="fas fa-filter"></i></button>
                  </div>
                    <!-- Table Search -->
                    <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                        <thead class="thead-light psticky">
                        <tr>
                            <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'boughtDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'boughtDate'  ? 'sort-desc' : '']"  
                                @click="sort('boughtDate')" >BOUGHT DATE</th>
                                <th 
                                scope="col" 
                                class="sort text-left"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                                @click="sort('cusip')" >CUSIP</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                                @click="sort('quantity')" >QTY</th> 
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                                @click="sort('cost')" >COST</th> 
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'endOfDayQuantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'endOfDayQuantity'  ? 'sort-desc' : '']"  
                                @click="sort('endOfDayQuantity')" > End of Day Qty</th> 
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'notes'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'notes'  ? 'sort-desc' : '']"  
                                @click="sort('notes')" > notes</th> 
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'totPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'totPrice'  ? 'sort-desc' : '']"  
                                @click="sort('totPrice')" > Total Price</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'assignedTo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'assignedTo'  ? 'sort-desc' : '']"  
                                @click="sort('assignedTo')" > Assigned To</th>  
                                <th 
                                scope="col" 
                                class="sort text-center"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'broughtIn'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'broughtIn'  ? 'sort-desc' : '']"  
                                @click="sort('broughtIn')" > Bought Account </th>
                                <th 
                                scope="col" 
                                class="text-center">Action</th>  
                        </tr>
                        </thead>
                        <tbody class="list no-cursor">
                        <tr v-if="totalRows == 0 && !loading">
                            <td><p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="inventory in inventoryList" :key="inventory.id" >
                            <td class="text-center">
                                <span v-bind:class="[inventory.boughtDateIsinRange ? 'color-purple' : '']">{{ inventory.boughtDate ? moment(inventory.boughtDate).format("MM/DD/YYYY") : "N/A"}}</span>
                            </td>
                            <td>
                                <span  v-bind:class="[inventory.source == 'MANUAL' ? 'color-light-blue' : '']">{{inventory.cusipVal}}</span>
                            </td>
                            <td class="text-center">
                                <span v-bind:class="[inventory.source == 'MANUAL' ? 'color-light-blue' : '']">{{inventory.quantity}}</span>
                            </td>
                            <td class="text-center">
                                <span  v-bind:class="[inventory.source == 'BOTIN' ? 'color-orange' : '']">{{inventory.cost | currency}}</span>
                                
                            </td>
                            <td class="text-center">
                                <span  v-if="inventory.endOfDayQuantity" v-bind:class="[(inventory.endOfDayQuantity) != inventory.quantity ? 'color-light-orange' : '']">{{inventory.endOfDayQuantity}}</span>
                            </td>
                            <td class="text-center">
                                <span v-if="inventory.notes" v-bind:class="[inventory.notes && inventory.notes.toLowerCase().includes('bw') ? 'color-yellow' : '']">{{inventory.notes}}</span>
                            </td>
                            <td class="text-center">{{(inventory.cost * (inventory.endOfDayQuantity * 10)) | currency }}</td>
                            <td class="text-center">
                                <span v-bind:class="[inventory.source == 'BOTIN' ? 'color-light-blue' : '']">{{inventory.assToUserFirstLastName}}</span>
                            </td>
                            <td class="text-center">{{inventory.broughtIn}}</td>
                            <td class="text-center">
                                <div class="d-inline-flex"> 
                                    <a  @click="openAddInvModal(inventory)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                                    <a  @click="checkOfferExist(inventory)" class="btn ibtn btn-outline-danger"><i class="fas fa-trash-alt"></i></a>

                                </div>    
                            </td>
                        </tr>
                        </tbody>
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                    </table>
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getInventoryList(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                   
                </div>
            </div>
        </div>
      </div>
      <addNewInventory v-if="addInvModalOpen" v-bind:selectedInventory="selectedInventory"  v-bind:mode="'EDIT'" @close="closeAddInvModal()" />
        <updateErrorInv v-if="editErrorInventoryOpen" v-bind:inventoryData="errorInvData"  @close="closeErroInvModal()" />
    </div>                

</template>
<script>

import config from "@/config";
import authService from "@/authService";
import addNewInventory from "../ims-inventory/ImsAddInventoryModal";
import updateErrorInv from "../ims-inventory/ImsInventoryErrorEditModal"
export default {
  name: "imsinventoryListError",
  components :{
      addNewInventory,
      updateErrorInv
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "account",
        sortOrder: "ASC",
        inventoryList : [],
        addInvModalOpen : false,
        selectedInventory : {},
        invNoAccountWarningMessage : "PLEASE ADD THIS ACCOUNT TO CUSTOMER TO RESOLVE",
        editErrorInventoryOpen : false,
        errorInvData : null,
        invHoldingFrom : null,
        invHoldingTo : null,
        overDueDays : null,
        userList : [],
        filterUser : null,
        totalPrice : null,
        totalCount : null,
       
    };
  },
  methods: { 

    changeFilter(){
        setTimeout(()=>{
            this.searchInventory()
        },100)
    },
    checkOfferExist(inv){
         this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .get(config.baseUrlBidSide + "/inventory/is-offer-exist?inventoryId="+inv.id,auth)
            .then((result) => {
                this.loading = false;
                if(result.data.isOfferExist){
                    this.$alert("Can't delete or update. There is an existing offer for this holding","","warning")
                }else if(result.data.isBidWantedExist){
                    this.$alert("Can't delete or update. There is an existing bid wanted for this holding","","warning")
                }
                else{
                   this.deleteInv(inv)
                }              
                // console.log(result.data)         
            })
            .catch(() => {
                this.loading = false;              
            });
    },
    openAddInvModal(data){
      this.selectedInventory = data;  
      this.addInvModalOpen = true;
    }, 
    closeAddInvModal(){
      this.addInvModalOpen = false;
      this.getInventoryList();
    },
    openEditErrorInvModal(data){
        this.errorInvData = data
        this.editErrorInventoryOpen = true;

    },  
    closeErroInvModal(){
        this.editErrorInventoryOpen = false;
        this.getInventoryList(); 

    },
    searchInventory(){
        this.getInventoryList(); 
    },
    clearSearch(){
        this.searchValue = "";
        this.getInventoryList(); 
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getInventoryList();
    },

    getInventoryList(){
        this.loading = true;
    
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/inventory/listall-invholdings?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
            authService.getUser().cognitoSub+
            "&assignedTo="+
            (this.filterUser ? this.filterUser.id : ""),
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          //this.totalCount = result.data.pageInfo.sumOfQuantity || 0;
          //this.totalPrice = result.data.pageInfo.totalPrice;
          result.data.content.forEach(element => {
            if(element.isMargin === null || element.isMargin === ""){
               element.isMargin = "N/A";
            }else{
              element.isMargin ? element.isMargin = "YES" : element.isMargin = "NO"
            }
            let invBoughtDate = this.moment(element.boughtDate);
            let currentDate = this.moment();
            let differenceInDays = currentDate.diff(invBoughtDate, 'days');
            if(this.overDueDays){
                if(differenceInDays <=  this.overDueDays){
                    element.boughtDateIsinRange = false
                }else{
                    element.boughtDateIsinRange = true
                }
            }
          
           });
          this.inventoryList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    resolveInv(inv){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        inv.isMargin == "YES"  ? inv.isMargin = true : inv.isMargin = false;
        this.$http
        .put(config.baseUrlBidSide + "/inventory/update-waiting-inventory", inv, auth)
        .then((result) => {
            let message = "Inventory "+result.data;
            this.$alert(message,"","success")
            this.getInventoryList();
            this.$root.$emit("invadded");              
        })
        .catch(() => {
                          
        });
        
    },
    resolveAllInv(){
        this.loading = true;

      const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .put(config.baseUrlBidSide + "/inventory/refresh-waiting-inventory",{cognitoSub:authService.getUser().cognitoSub},auth)
        .then(() => {
            // let message = result.data.ADDED ? result.data.ADDED : 0 + " Inventory Added"
            this.$alert("Resolve is under process...","","success")
            this.getInventoryList();
            this.$root.$emit("invadded");  
            this.loading = false;
        })
        .catch(() => {
            this.loading = false;               
        });
    },
    deleteInv(inv){
        if(this.isUploadInProgress()){
            this.$alert("Holding upload is currently in progress. Please try again once it’s complete.","","info")

        }else{
            var message = "Are you sure you want to delete this holding?";
            this.$confirm(message,"Delete holding","question",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .put(config.baseUrlBidSide + "/inventory/delete?inventoryId="+inv.id,"",auth)
                .then(() => {
                    this.loading = false;              
                    this.getInventoryList();              
                })
                .catch(() => {
                    this.loading = false;              
                });
            });
        }

    },
    getUserSetting(){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                result.data.forEach(element => {
                    if(element.setting == "INVENTORY_HOLDING_OVERDUE_PUCHASE_DAYS"){
                        this.overDueDays = element.value ?  Number(element.value) : null
                    }
                   
                });
                this.getInventoryList();
                //this.loading = false;
            })
            .catch(e => {
                console.log(e);
            });
    },
    getUserList(){             
        const auth = {
            headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=",
                auth
            )
            .then(result => {
            result.data.content.forEach(trader =>{
                trader.firstName =  trader.firstName+" "+trader.lastName;
            });
            this.userList = result.data.content;

            this.filterUser = this.userList.find((user) => user.id == this.selectedInventory.assignedTo)
            
            })
            .catch(e => {
            console.log(e);
            });
    },
   
   
  },
  mounted() {
    this.getUserSetting();
    this.getUserList();
    //  this.$root.$on("searchInventoryError", (data) => {
    //     console.log("on Error",data.searchValue);
    //     this.searchValue = data.searchValue;
    //     this.getInventoryList(); 
    // });
    this.$root.$on("refresh", () => {
        this.getInventoryList(); 
    });
    this.$root.$on("INVENTORY_HOLDING_TOTALS", (data) => {
        // this.getInventoryList(); 
      this.totalPrice = JSON.parse(data.count.totalPrice);
      this.totalCount = JSON.parse(data.count.totalEodQty);

    });
  },
  beforeDestroy() {
    this.$root.$off("INVENTORY_HOLDING_TOTALS");
    this.$root.$off("refresh");
  },
};
</script>
<style>
.trader-filter {
    position: absolute;
    right: 262px;
    top: 134px;
    z-index: 9999;
    width: 219px;
}
.trader-count {
    position: absolute;
    right: 550px;
    top: 134px;
    z-index: 9999;
    width: 219px;
}

</style>